exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tooltip-detail{\r\n    text-align: left;\r\n}\r\n.tooltip-origin {\r\n    width:auto;\r\n    display: inline-block;\r\n    padding: 7px 18px;\r\n    background:teal;\r\n    color: #fff;\r\n    border-radius: 4px;\r\n}\r\nimg {\r\n    width: 300px;\r\n    max-width: 90%;\r\n}\r\n.hr-line {\r\n    border-top: 1px solid #e7eaec;\r\n    color: #ffffff;\r\n    background-color: #ffffff;\r\n    height: 1px;\r\n    margin: 20px 0;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/padriana/gorent-panel/src/app/dashboard/contract/contract.component.css
// module id = ../../../../../src/app/dashboard/contract/contract.component.css
// module chunks = main